import { render } from "./conversationLabel.vue?vue&type=template&id=976700f6"
import script from "./conversationLabel.vue?vue&type=script&lang=js"
export * from "./conversationLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__